import Vue from 'vue'
import '@/plugins/element-ui.js'
// import FaConsts from "@/plugins/fa.js";

// Vue.use(FaConsts);

import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
Vue.use(VuePersianDatetimePicker, {
  name: 'date-picker',
  props: {
    color: '#151515',
    autoSubmit: true,
  },
})

import vuePersianFilters from 'vue-persian-filters'
Vue.use(vuePersianFilters)
